<template>
	<div>
		<!-- _CONTENT 
		---------------------------------------->
		<div v-if="checkupDetail.type == '_CONTENT'" class="content">
 				<div v-for="(value,index) in checkupDetail.child1" :key="index" >
					<div v-if="value.child1 != null" > 	
						 <checkup-detail v-bind="{checkupDetail:value, textSign:textSign }" />
					 </div> 
					 <div v-else >
						<checkup-element v-bind="{element:value, textSign:textSign }" />
					 </div>
                </div>
		</div>
		<!-- Super Bloc 
		---------------------------------------->
		<div v-else-if="checkupDetail.type == 'superBlocValeur'"  class="superBloc">
			<div class="colorS superBloc-title" :class="'area-name-'+checkupDetail.value">{{checkupDetail.libelle}} : {{checkupDetail.value}}</div>
			<div class="superBloc-style">
 				<div v-for="(value,index) in checkupDetail.child1" :key="index" >
					 <div v-if="value.child1 != null" >
						 <checkup-detail v-bind="{checkupDetail:value, textSign:textSign }" />
					 </div>
					 <div v-else >
						<checkup-element v-bind="{element:value, textSign:textSign }" />
						
					 </div>
                </div>
			</div>
		</div>


		<!-- Super Bloc 
		---------------------------------------->
		<div v-else-if="checkupDetail.type == 'superBloc'"  class="superBloc">
			<div class="colorS superBloc-title"> <span class="one-letter">{{titlesuperBloc}}</span> {{checkupDetail.libelle}} </div>
			<div class="superBloc-style">
 				<div v-for="(value,index) in checkupDetail.child1" :key="index" >
					 <div v-if="value.child1 != null" >
						 <checkup-detail v-bind="{checkupDetail:value, textSign:textSign }" />
					 </div>
					 <div v-else >
						<checkup-element v-bind="{element:value, textSign:textSign }" />
					 </div>
                </div>
			</div>
		</div>
		<!-- Super Bloc sans lettre dans carré
		---------------------------------------->
		<div v-else-if="checkupDetail.type == 'superBlocSans'"  class="superBloc">
			<div class="colorS superBloc-title">{{checkupDetail.libelle}} </div>
			<div class="superBloc-style">
 				<div v-for="(value,index) in checkupDetail.child1" :key="index" >
					 <div v-if="value.child1 != null" >
						 <checkup-detail v-bind="{checkupDetail:value, textSign:textSign }" />
					 </div>
					 <div v-else >
						<checkup-element v-bind="{element:value, textSign:textSign }" />
					 </div>
                </div>
			</div>
		</div>
		<!-- Bloc 
		---------------------------------------->
		<div v-else-if="checkupDetail.type == 'bloc'"  class="bloc">
			<span> {{checkupDetail.libelle}} </span>
			<div class="card-style">
 				<div v-for="(value,index) in checkupDetail.child1" :key="index" >
					 <div v-if="value.child1 != null" >
						 <checkup-detail v-bind="{checkupDetail:value, textSign:textSign }" />
					 </div>
					 <div v-else >
						<checkup-element v-bind="{element:value, textSign:textSign }" />
					 </div>
                </div>
			</div>
		</div>

		<!-- Bloc Ligne
		---------------------------------------->
		<div v-else-if="checkupDetail.type == 'blocLigne'"   class="blocLigne">
			<div class="blocLigne-title">
				<span > {{checkupDetail.libelle}} </span>
			</div>
			
			<hr>
			<div class="blocLigne-content" >
 				<div v-for="(value,index) in checkupDetail.child1" :key="index" >
					 <div v-if="value.child1 != null" >
						 <checkup-detail v-bind="{checkupDetail:value, textSign:textSign }" />
					 </div>
					 <div v-else >
						<checkup-element v-bind="{element:value, textSign:textSign }" />
					 </div>
                </div>
			</div>
		</div>

		<!-- Groupe / Texte / Booleen / Temps / Image
		---------------------------------------->
		<div v-else >
			<checkup-element v-bind="{element:checkupDetail, textSign:textSign }" />
		</div>

	</div>
</template>

<script>
import CheckupElement from '@/components/checkup.detail.element.component.vue'

export default {
	props: ['checkupDetail','textSign'],
	name: 'checkupDetail',
	components: { CheckupElement },
	computed: {
		titlesuperBloc: function (){
			return	this.checkupDetail.libelle[0];
		}
	}
};
</script>

<style scoped>


.card-style{
	border-style: solid;
	border-width: 1px;
	border-color: black;
	margin: 3px;
	border-radius: 4px;
}

.blocLigne-title {
	padding-left: 10px;
}

.bloc {
	padding-left: 10px;
	padding-right: 10px;
}

.bloc hr{
	margin: auto;
}

.blocLigne-content{
	padding-left: 20px;
	padding-right: 10px;
}


.superBloc {
	padding-left: 5px;
	padding-right: 5px;
	margin-top:5px;
	margin-bottom:5px;
}

.superBloc-style{
	border-style: solid;
	border-width: 2px;
	border-color: rgb(13, 108, 193);
	background-color: white;
	border-radius: 0px 0px 4px 4px;
}


.superBloc-title{
	padding: 3px;
	border-radius: 4px 4px 0px 0px;
}

.one-letter{
	background-color: white;
	color: black;
	padding-left: 6px;
	padding-right: 6px;
	border-radius: 4px;
}

</style>
